var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18.125,
    viewBox: "0 0 15 18.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#575757;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-13.75,10.625a6.25,6.25,0,0,0,6.25,6.25,6.25,6.25,0,0,0,6.25-6.25A6.25,6.25,0,0,0-7.5,4.375h-3.863l2.238,2.244L-10,7.5l-3.75-3.75L-10,0l.875.881-2.244,2.244H-7.5a7.5,7.5,0,0,1,7.5,7.5,7.5,7.5,0,0,1-7.5,7.5,7.5,7.5,0,0,1-7.5-7.5Z",
    transform: "translate(15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.c568fa783d9c5fd356fb9f4670ed927f.svg";
export { ForwardRef as ReactComponent };